import { SVGProps } from 'react';

const Startup = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M11.25 21v-7.718l-6.882 3.871a.75.75 0 0 1-.736-1.306L10.47 12 3.632 8.153a.75.75 0 0 1 .736-1.306l6.882 3.87V3a.75.75 0 0 1 1.5 0v7.717l6.882-3.87a.75.75 0 0 1 .736 1.306L13.53 12l6.84 3.847a.75.75 0 0 1-.737 1.306l-6.882-3.87V21a.75.75 0 0 1-1.5 0Z"
    />
  </svg>
);

export default Startup;
